export function getAxiosConfig() {
  return {
    baseURL: "/api/container",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    withCredentials: process.env.NODE_ENV !== "test"
  };
}
